import React from 'react';
import ServicesSection from './ServicesSection';

const About = () => {
    return (
        <div>
            <ServicesSection />
        </div>
    );
};

export default About;